module.exports = __webpack_public_path__ + "img/product-shansuan-zsyy-06.0fe0e2a8.png";